
(function () {
  'use strict';

  const STYLE_ID = 'lr-responsive-gallery-css';
  const MIN_WIDTH = 1024;
  const MAX_WIDTH = 1279;

  let refreshTimer = null;
  let lastMode = null;

  const galleryCSS = `
    @media screen and (min-width: 1024px) and (max-width: 1279px) {

      .halo-productView-left .productView-images-wrapper {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        gap: 12px !important;
      }

      .halo-productView-left .productView-image-wrapper {
        display: block !important;
        order: 1 !important;
        position: relative !important;
        flex: 0 0 auto !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
      }

      .halo-productView-left .productView-nav {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
      }

      .halo-productView-left .productView-thumbnail-wrapper {
        display: block !important;
        order: 2 !important;
        position: relative !important;
        top: auto !important;
        right: auto !important;
        bottom: auto !important;
        left: auto !important;
        flex: 0 0 auto !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        margin: 0 !important;
      }

      .halo-productView-left .productView-for {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
      }

      

      .halo-productView-left .productView-for .slick-list {
        width: 100% !important;
        max-width: 100% !important;
      }
    }
  `;

  function isTargetScreen() {
    return window.innerWidth >= MIN_WIDTH &&
           window.innerWidth <= MAX_WIDTH;
  }

  function addGalleryCSS() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = galleryCSS;
    document.head.appendChild(style);
  }

  // Remove only inline styles added by this script.
  function restoreOriginalLayout(root) {
    if (!root) return;

    const selectors = [
      '.productView-images-wrapper',
      '.productView-image-wrapper',
      '.productView-nav',
      '.productView-thumbnail-wrapper',
      '.productView-for'
    ];

    selectors.forEach(function (selector) {
      const element = root.querySelector(selector);
      if (!element) return;

      [
        'display',
        'flex-direction',
        'align-items',
        'width',
        'max-width',
        'min-width',
        'height',
        'gap',
        'order',
        'position',
        'flex',
        'top',
        'right',
        'bottom',
        'left',
        'margin'
      ].forEach(function (property) {
        element.style.removeProperty(property);
      });
    });
  }

  function setImportant(element, property, value) {
    if (element) {
      element.style.setProperty(property, value, 'important');
    }
  }

  function refreshSlick(root) {
    if (!window.jQuery) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        [
          root.querySelector('.productView-nav'),
          root.querySelector('.productView-for')
        ].forEach(function (slider) {
          if (!slider) return;

          const $slider = window.jQuery(slider);

          if ($slider.hasClass('slick-initialized')) {
            try {
              $slider.slick('setPosition');
            } catch (error) {
              console.warn('Lorianne Slick refresh:', error);
            }
          }
        });
      });
    });
  }

  function applyResponsiveLayout(root) {
    if (!root) return;

    const wrapper = root.querySelector('.productView-images-wrapper');
    const imageWrapper = root.querySelector('.productView-image-wrapper');
    const nav = root.querySelector('.productView-nav');
    const thumbnailWrapper = root.querySelector('.productView-thumbnail-wrapper');
    const thumbs = root.querySelector('.productView-for');

    if (!wrapper || !imageWrapper || !nav ||
        !thumbnailWrapper || !thumbs) return;

    setImportant(wrapper, 'display', 'flex');
    setImportant(wrapper, 'flex-direction', 'column');
    setImportant(wrapper, 'align-items', 'stretch');
    setImportant(wrapper, 'width', '100%');
    setImportant(wrapper, 'max-width', '100%');
    setImportant(wrapper, 'min-width', '0');
    setImportant(wrapper, 'height', 'auto');
    setImportant(wrapper, 'gap', '12px');

    setImportant(imageWrapper, 'display', 'block');
    setImportant(imageWrapper, 'order', '1');
    setImportant(imageWrapper, 'position', 'relative');
    setImportant(imageWrapper, 'flex', '0 0 auto');
    setImportant(imageWrapper, 'width', '100%');
    setImportant(imageWrapper, 'max-width', '100%');
    setImportant(imageWrapper, 'min-width', '0');
    setImportant(imageWrapper, 'height', 'auto');

    setImportant(nav, 'display', 'block');
    setImportant(nav, 'width', '100%');
    setImportant(nav, 'max-width', '100%');
    setImportant(nav, 'min-width', '0');

    setImportant(thumbnailWrapper, 'display', 'block');
    setImportant(thumbnailWrapper, 'order', '2');
    setImportant(thumbnailWrapper, 'position', 'relative');
    setImportant(thumbnailWrapper, 'top', 'auto');
    setImportant(thumbnailWrapper, 'right', 'auto');
    setImportant(thumbnailWrapper, 'bottom', 'auto');
    setImportant(thumbnailWrapper, 'left', 'auto');
    setImportant(thumbnailWrapper, 'flex', '0 0 auto');
    setImportant(thumbnailWrapper, 'width', '100%');
    setImportant(thumbnailWrapper, 'max-width', '100%');
    setImportant(thumbnailWrapper, 'min-width', '0');
    setImportant(thumbnailWrapper, 'height', 'auto');
    setImportant(thumbnailWrapper, 'margin', '0');

    setImportant(thumbs, 'display', 'block');
    setImportant(thumbs, 'width', '100%');
    setImportant(thumbs, 'max-width', '100%');
    setImportant(thumbs, 'min-width', '0');

    refreshSlick(root);
  }

  function updateGallery() {
    const targetMode = isTargetScreen() ? 'responsive' : 'original';

    if (targetMode === lastMode) {
      if (targetMode === 'responsive') {
        document.querySelectorAll('.halo-productView-left')
          .forEach(applyResponsiveLayout);
      }
      return;
    }

    lastMode = targetMode;

    document.querySelectorAll('.halo-productView-left').forEach(function (root) {
      if (targetMode === 'responsive') {
        applyResponsiveLayout(root);
      } else {
        restoreOriginalLayout(root);
        refreshSlick(root);
      }
    });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(function () {
      updateGallery();
    }, 200);
  }

  function initializeGallery() {
    addGalleryCSS();
    updateGallery();
  }

  window.addEventListener('load', initializeGallery);
  window.addEventListener('resize', scheduleRefresh);
  window.addEventListener('orientationchange', scheduleRefresh);

  document.addEventListener('DOMContentLoaded', initializeGallery);
  document.addEventListener('variant:change', scheduleRefresh);
  document.addEventListener('product:variant-change', scheduleRefresh);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initializeGallery, 250);
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('.productView, .product-form, [data-product-option]')) {
      scheduleRefresh();
    }
  });

  initializeGallery();

})();
